import { useEffect, useRef, useState } from "react";

import deepEqual from "deep-equal";

function mapSelf(d) {
	return d;
}

export function useAttributes(editor, attrbute, defaultValue, map) {
	const mapFn = map || mapSelf;
	const [value, setValue] = useState(mapFn(defaultValue));
	const prevValueCache = useRef(value);

	useEffect(() => {
		const listener = () => {
			const attrs = { ...defaultValue, ...editor.getAttributes(attrbute) };
			Object.keys(attrs).forEach(key => {
				if (attrs[key] === null || attrs[key] === undefined) {
					// @ts-ignore
					attrs[key] = defaultValue[key];
				}
			});
			const nextAttrs = mapFn(attrs);
			if (deepEqual(prevValueCache.current, nextAttrs)) {
				return;
			}
			setValue(nextAttrs);
			prevValueCache.current = nextAttrs;
		};

		editor.on("selectionUpdate", listener);
		editor.on("transaction", listener);

		return () => {
			editor.off("selectionUpdate", listener);
			editor.off("transaction", listener);
		};
	}, [editor, defaultValue, attrbute, mapFn]);

	return value;
}
